import { render, staticRenderFns } from "./ssologin.vue?vue&type=template&id=98bae990"
import script from "./ssologin.vue?vue&type=script&lang=js"
export * from "./ssologin.vue?vue&type=script&lang=js"
import style0 from "./ssologin.vue?vue&type=style&index=0&id=98bae990&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports